<form name="clientAddForm" #clientAddForm="ngForm" (ngSubmit)="ok()" novalidate class="form-v2">
    <div class="modal-header">
        <h4 class="modal-title">New Client</h4>
    </div>
    <div class="modal-body">
        <div class="form-group">
            <label class="text-info"><span class="mandatory-field"></span>Name </label>
            <input
                legacy-css
                name="Name"
                type="text"
                placeholder="Name"
                class="form-control form-control-v2"
                [(ngModel)]="createOptions.Name"
                (ngModelChange)="nameChange()"
                required
                maxlength="50"
                autofocus />
            <div class="alert alert-danger margin-top-5" *ngIf="exists">This client already exists. Please enter a unique name.</div>
        </div>
        <div class="form-group">
            <label class="text-info"><span class="mandatory-field"></span>Client Type </label>
            <input
                legacy-css
                name="ClientType"
                type="text"
                [(ngModel)]="createOptions.CustomerType"
                placeholder="Client type..."
                [typeahead]="clientTypes"
                [typeaheadMinLength]="0"
                class="form-control form-control-v2"
                maxlength="50"
                required />
        </div>
        <div class="form-group">
            <label class="text-info"> How did they hear about you? </label>
            <input
                legacy-css
                name="Source"
                type="text"
                [(ngModel)]="createOptions.Source"
                placeholder="Source..."
                [typeahead]="estimateSources"
                [typeaheadMinLength]="0"
                class="form-control form-control-v2"
                typeahead-show-hint="true"
                typeahead-min-length="0" />
        </div>
        <div class="form-group">
            <label class="text-info"> Address </label>
            <app-bx-address-input
                inputClass="form-control form-control-v2"
                [inputLegacyCss]="true"
                inputMaxLength="100"
                name="Address"
                [(ngModel)]="createOptions.Address"
                (onAddressSelected)="handleAddressChange($event)" />
        </div>
        <div class="form-group">
            <label class="text-info" translate="general.address.city"></label>
            <input
                legacy-css
                name="CityTown"
                type="text"
                translate-attr="{placeholder: 'general.address.city'}"
                class="form-control form-control-v2"
                [(ngModel)]="createOptions.CityTown"
                maxlength="50" />
        </div>
        <div class="row">
            <div class="col-xs-6">
                <div class="form-group">
                    <label translate="general.address.state"></label>
                    <select legacy-css name="State" class="form-control form-control-v2" [(ngModel)]="createOptions.State">
                        <option value="">Please select</option>
                        <option *ngFor="let s of sharedData.Common.StatesInfo" [ngValue]="s.value">{{ s.value }}</option>
                    </select>
                </div>
            </div>
            <div class="col-xs-6">
                <div class="form-group">
                    <label translate="general.address.postcode"></label>
                    <input
                        legacy-css
                        name="PostCode"
                        type="text"
                        translate-attr="{placeholder: 'general.address.postcode'}"
                        class="form-control form-control-v2"
                        [(ngModel)]="createOptions.PostCode"
                        maxlength="10" />
                </div>
            </div>
        </div>
        <div class="form-group">
            <label class="text-info"> Phone </label>
            <div class="form-group">
                <phone-number
                    name="phoneCustom"
                    [number]="createOptions.Phone"
                    [(ngModel)]="createOptions.Phone"
                    (parsednumber)="createOptions.Phone = $event"></phone-number>
            </div>
        </div>
        <div class="form-group">
            <label class="text-info" translate="general.address.mobile"></label>
            <div class="form-group">
                <phone-number
                    name="mobileCustom"
                    [number]="createOptions.Mobile"
                    [(ngModel)]="createOptions.Mobile"
                    (parsednumber)="createOptions.Mobile = $event"></phone-number>
            </div>
        </div>
        <div class="form-group">
            <label class="text-info"> Email </label>
            <div class="form-group">
                <input
                    legacy-css
                    name="Email"
                    type="email"
                    email
                    placeholder="Email"
                    class="form-control form-control-v2"
                    [ngModelOptions]="{}"
                    [(ngModel)]="createOptions.Email"
                    maxlength="50" />
            </div>
        </div>
    </div>
    <div class="modal-footer new">
        <button type="button" class="btn-bx-secondary-stroked" (click)="cancel()">Cancel</button>
        <button type="submit" class="btn-bx-primary ml-2" [disabled]="clientAddForm.invalid">OK</button>
    </div>
</form>
